"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.preview.title': 'Dettagli della Conoscenza',
    'knowledge.preview.edit': 'Modifica',
    'knowledge.preview.back': 'Torna alla Lista',
    'knowledge.preview.not_found': 'Voce di conoscenza non trovata',
    'knowledge.preview.not_provided': 'Non fornito',
    'knowledge.preview.no_tags': 'Nessun tag',
    'knowledge.preview.no_file': 'Nessun file allegato',
    'knowledge.preview.error.load_failed': 'Errore nel caricamento della voce di conoscenza',
    'knowledge.preview.section.basic_info': 'Informazioni di Base',
    'knowledge.preview.section.file_info': 'Informazioni File',
    'knowledge.preview.section.content': 'Contenuto',
    'knowledge.preview.section.used_by_avatars': 'Usato da Avatar',
    'knowledge.preview.section.used_by_professions': 'Usato da Professioni',
    'knowledge.preview.section.errors': 'Errori',
    'knowledge.preview.content_type.text': 'Testo',
    'knowledge.preview.content_type.file': 'File',
    'knowledge.preview.content_type.link': 'Link',
    'knowledge.preview.content_type.google-drive': 'Google Drive',
    'knowledge.preview.rag_status.pending': 'In Attesa',
    'knowledge.preview.rag_status.processing': 'Elaborazione',
    'knowledge.preview.rag_status.completed': 'Completato',
    'knowledge.preview.rag_status.failed': 'Fallito',
    'knowledge.preview.rag_status.not_indexed': 'Non Indicizzato',
    'knowledge.preview.active.yes': 'Sì',
    'knowledge.preview.active.no': 'No',
    'knowledge.preview.no_avatars_using': 'Nessun avatar sta attualmente usando questa conoscenza',
    'knowledge.preview.no_professions_using': 'Nessuna professione sta attualmente usando questa conoscenza',
};
